import { makeAuthPlugin } from '@/api-client'

export default makeAuthPlugin({ userService: 'users' })
